import { User } from './types';

const isUserValid = (obj: unknown): obj is User => {
  if (typeof obj !== 'object' || obj === null) return false;

  const user = obj as Record<string, unknown>;

  return (
    'role' in user &&
    'game_name' in user &&
    'first_name' in user &&
    'last_name' in user &&
    user.game_name === 'smart_logs'
  );
};

const getUserInvalidErrorMessage = (obj: unknown): string => {
  const errorMessages = [];

  if (typeof obj !== 'object' || obj === null) {
    errorMessages.push('Your token probably does not correspond to any valid user.');
  }

  const user = obj as Record<string, unknown>;

  if (user.game_name !== 'smart_logs') {
    errorMessages.push('The user does not have a valid `game_name` field.');
  }

  errorMessages.push('Please, contact the admin to solve this problem.');

  return errorMessages.join('\n');
};

export { isUserValid, getUserInvalidErrorMessage };
